module["exports"] = [
  "0.#.#",
  "0.##",
  "#.##",
  "#.#",
  "#.#.#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/app/version.js
// module id = 1400
// module chunks = 0